import {Badge, Tooltip} from '@mantine/core';
import classNames from 'classnames';
import {useEffect, useRef, useState} from 'react';
import {MdInfoOutline} from 'react-icons/md';
import type {WorkAttractiveConditionType} from '../../../../../core/entities/company/schema';

type Props = {
  workAttractiveConditions: WorkAttractiveConditionType[];
};
const maxHeightBadge = 46;
const maxHeightBadgeStyle = 'max-h-[46px] pc:max-h-full';

export const AttractiveConditions: React.FC<Props> = ({
  workAttractiveConditions,
}) => {
  const refBadge = useRef<HTMLDivElement>(null);
  const [clampedBadge, setClampedBadge] = useState(false);
  const [expandedBadge, setExpandedBadge] = useState(false);

  // categoryID 1 年収の条件があるかどうかをチェック
  const hasSalaryCondition = workAttractiveConditions.some(
    (condition) => condition.categoryID === 1,
  );

  useEffect(() => {
    const ref = refBadge.current;
    if (!ref) return;
    if (ref.scrollHeight > maxHeightBadge) {
      setClampedBadge(true);
    }
  }, []);

  return (
    <div className="flex px-16 items-end justify-between pc:px-0">
      <div
        className={classNames('overflow-hidden transition-all duration-300', {
          'max-h-full': expandedBadge,
          [maxHeightBadgeStyle]: !expandedBadge,
        })}
      >
        <div
          className="flex flex-wrap text-sm font-bold items-center"
          ref={refBadge}
        >
          {workAttractiveConditions.map((condition) => (
            <Badge
              key={condition.id}
              className="rounded-16 bg-category-10 text-white px-8 py-4 mt-[2px] mr-4"
            >
              {condition.name}
            </Badge>
          ))}
          {hasSalaryCondition && (
            <Tooltip
              label="表示の年収は理論年収（賞与込み）となります"
              withArrow
              events={{hover: true, focus: false, touch: true}}
              classNames={{
                tooltip: 'bg-white text-black-1 text-sm shadow-card',
              }}
              styles={{
                tooltip: {
                  fontWeight: 'normal',
                },
              }}
            >
              <div>
                <MdInfoOutline className="text-primary" size={24} />
              </div>
            </Tooltip>
          )}
        </div>
      </div>

      {clampedBadge && (
        <div className="flex pc:hidden">
          <div
            className="text-sm font-bold text-black-1 cursor-pointer hover:opacity-70 whitespace-nowrap"
            onClick={() => setExpandedBadge((prev) => !prev)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                setExpandedBadge((prev) => !prev);
              }
            }}
          >
            {expandedBadge ? '閉じる' : 'もっとみる'}
          </div>
        </div>
      )}
    </div>
  );
};
